import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StagePalette({ palette, stageLabel, onPickStage }) {
    return (_jsxs("div", { "data-menu-keep": "1", style: {
            position: 'absolute',
            left: 12,
            bottom: 12,
            zIndex: 20,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            background: '#FFFFFF',
            border: '1px solid #E2E8F0',
            borderRadius: 12,
            padding: '8px 12px',
            boxShadow: '0 6px 20px rgba(15,23,42,.14)',
        }, children: [_jsx("span", { style: { fontSize: 11, color: '#64748B' }, children: "\u0418\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442:" }), palette.map((p) => (_jsx("button", { type: "button", onClick: () => onPickStage(p.key), title: p.label, style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 11,
                    color: '#334155',
                    width: 22,
                    height: 22,
                    borderRadius: 6,
                    border: '1px solid rgba(15,23,42,.12)',
                    background: p.bg,
                    cursor: 'pointer',
                    boxShadow: p.ring,
                    padding: 0,
                    flex: 'none',
                }, children: p.txt ?? null }, p.key))), _jsx("span", { style: { fontSize: 11.5, fontWeight: 600, minWidth: 80 }, children: stageLabel }), _jsx("span", { style: { fontSize: 10.5, color: '#94A3B8' }, children: "\u043F\u0440\u043E\u0442\u044F\u0436\u043A\u0430 \u043F\u043E \u043F\u0443\u0441\u0442\u043E\u043C\u0443 \u043C\u0435\u0441\u0442\u0443 \u2014 \u043D\u043E\u0432\u0430\u044F \u0441\u0442\u0430\u0434\u0438\u044F \u00B7 \u043A\u043B\u0438\u043A \u043F\u043E \u0441\u0442\u0430\u0434\u0438\u0438 \u2014 \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u00B7 2 \u043A\u043B\u0438\u043A\u0430 \u2014 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430" })] }));
}
